import React from 'react';
import { H6 } from '../../../AbstractElements';

const NotificationSlider = () => {
  return (
    <div className='notification-slider overflow-hidden '>
      <div className='d-flex h-100'>
        <H6 attrH6={{ className: 'mb-0 f-w-400' }}>
          <span className='f-light' style={{ "color": "#890077" }}>A unique gift that lasts</span>
        </H6>
      </div>
    </div>
  );
};

export default NotificationSlider;
